import React, { useState, useEffect, useRef, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router";
import { UrlPath } from "../../../../../config/routeConfig";
import { getProformaListAction, getProformaTreeListAction, getProformaEntitiesAction } from "../../../../actions/proformaAction";
import moment from "moment";
import { updateProforma, saveProforma, getProforma } from "../../../../../config/apiConfig";
import { sbaAxios } from "../../../../utils/sbaAxios";
import { ToastContainer, toast } from 'react-toastify';
import { SBNotify } from "../../../../utils/sbNotify";
import { SBADrawer } from "../../../../UiComponents/SBADrawer";
import { AssetandGroup } from "./AssetandGroup";
import $ from "jquery";
import "../ProformaConstruction.css";
import { AutoComplete } from "@progress/kendo-react-dropdowns";
import { getEntities } from "../../../../../config/apiConfig";
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { LoadingScreen } from "../../../../UiComponents/LoadingComponent";
export const ProformasTreeGrid = ({

    ProformaDetails,
    ActiveButton,
    allocationParams,
    setAllocationParams,
    setProfromaID,
    ProfromaID
}) => {
    //let proformaId = ProformaDetails?.HPId;
    const dispatch = useDispatch();
    const history = useNavigate();
    let rowData;
    const [entityData, setEntityData] = useState([]);

    const Gstate = useSelector((state) => state) || {};
    const isEditable = Gstate.authorizationData.isEditable;
    const proformaTreeListData = Gstate.ProformaConstruction.ProformaTreeListData || [];
    const [proformaId, setproformaId] = useState(ProfromaID || 0);
    const [isSaving, setIsSaving] = useState(false);
    const [updateMessage, setUpdateMessage] = useState("");
    useEffect(() => {
        if (ActiveButton !== "CreateNewProfoma") {
            setproformaId(ProfromaID);
            dispatch(getProformaTreeListAction(proformaId));
        }

    }, [ActiveButton]);



    const Entities = Gstate.ProformaConstruction.ProformaEntitiesData || [];

    const [showDrawer, setShowDrawer] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [saveAs, setSaveAs] = useState(false);
    const [addAssets, setAddAssets] = useState(false);
    const [showsave, setshowsave] = useState(false);
    const [hpName, setHpName] = useState(proformaTreeListData?.HPName);
    const [description, setDescription] = useState(proformaTreeListData?.Description);
    const [isSaveLoading, setIsSaveLoading] = useState(false);
    const [rowDataState, setRowDataState] = useState([]);
    const [proxyList, setProxyList] = useState([]);
    useEffect(() => {
        if (ActiveButton !== "CreateNewProfoma") {
            let total = 0;
            const generatedData = proformaTreeListData?.HypoAllocations || [];
            setRowDataState([]);
            generatedData.forEach((allocation) => {
                total = total + (allocation?.Position / 10000);
                const childEntities = proformaTreeListData?.HypoEntities.filter(
                    (entity) => entity?.StrategyId === allocation?.StrategyId
                );
                const childRows = childEntities.map((childEntity) => {
                    const childCurAllocation = childEntity?.Allocations.reduce(
                        (acc, allocation) => {
                            return acc + (allocation?.Position || 0);
                        },
                        0
                    );
                    const childPerAllocation = childEntity?.Allocations.reduce(
                        (acc, allocation) => {
                            return acc + allocation?.Percentage;
                        },
                        0
                    );
                    const childAllocDate = childEntity?.Allocations.reduce(
                        (acc, allocation) => {
                            return acc + allocation.AllocDate != null ? moment(allocation?.AllocDate).format(
                                "MM-DD-YYYY"
                            ) : null;
                        },
                        ""
                    );

                    return {
                        Id: childEntity?.Id,
                        HypoId: childEntity?.HypoId,
                        StrategyId: childEntity?.StrategyId,
                        EntityId: childEntity?.EntityId,
                        EntityType: childEntity?.EntityType,
                        SecMasterId: childEntity?.SecMasterId,
                        StrategyName: childEntity?.StrategyName,
                        EntityName: childEntity?.EntityName,
                        AllocDate: childAllocDate,
                        StartDate: childEntity ? childEntity.StartDate == null ? new Date() : childEntity.StartDate : null,
                        EndDate: childEntity ? childEntity.EndDate == null ? new Date() : childEntity.EndDate : null,
                        CurAllocation: childCurAllocation,
                        PerAllocation: (childPerAllocation * 100).toFixed(6),
                        SortOrder: childEntity?.SortOrder,
                        ProxyBenchmarkId: childEntity?.ProxyBenchmarkId,
                        ProxyBenchmarkType: childEntity?.ProxyBenchmarkType,
                        ProxyData: [{
                            EntityId: childEntity ? childEntity.ProxyBenchmarkId : null,
                            EntityName: childEntity && childEntity.ProxyName !== null ?
                                childEntity.ProxyName.toLowerCase()
                                : childEntity.ProxyName
                        }],
                    };
                });

                const parentRow = {
                    HypoId: allocation?.HypoId,
                    StrategyId: allocation?.StrategyId,
                    StrategyName: allocation?.StrategyName,
                    EntityId: allocation?.EntityId,
                    EntityName: null,
                    StartDate: null,
                    EndDate: null,
                    CurAllocation: allocation?.Position,
                    PerAllocation: (allocation?.Position / 10000).toFixed(6),
                    ChildData: [{ childRows }],
                };

                setRowDataState((prevData) => [...prevData, parentRow]);
            });
            $("#StrategyTotal").text(parseFloat(total).toFixed(6) + "%");

        } else {
            const groupedData = {};

            selectedRows.forEach((row) => {
                const { StrategyName, EntityName, StartDate, EndDate, EntityId } = row;

                if (!groupedData[StrategyName]) {
                    groupedData[StrategyName] = {
                        StrategyId: row.StrategyId,
                        StrategyName,
                        EntityName: null,
                        StartDate: null,
                        EndDate: null,
                        CurAllocation: "",
                        PerAllocation: "",
                        ChildData: [{ childRows: [] }],
                    };
                }

                const existingRow = groupedData[StrategyName].ChildData[0].childRows.find(childRow => childRow.EntityId === EntityId);

                if (!existingRow) {
                    groupedData[StrategyName]?.ChildData[0].childRows.push({
                        EntityId,
                        EntityName,
                        StrategyName,
                        StartDate,
                        EndDate,
                        CurAllocation: "",
                        PerAllocation: "",
                    });
                }
            });

            rowData = Object.values(groupedData);
            rowData.forEach((parentRow) => {
                parentRow.PerAllocation *= 100;
            });

        }
        setHpName(proformaTreeListData?.HPName)
    }, [proformaTreeListData]);

    const handleDragStart = (e, parentIndex, childIndex) => {
        e.dataTransfer.setData('text/plain', JSON.stringify({ parentIndex, childIndex }));
    };

    const handleDragOver = (e, parentIndex, childIndex) => {
        e.preventDefault();

    };

    const handleDrop = (e, parentIndex, childIndex) => {
        e.preventDefault();
        const draggedData = JSON.parse(e.dataTransfer.getData('text/plain'));
        const updatedRows = [...rowDataState];

        const draggedRow = updatedRows[draggedData.parentIndex].ChildData[0].childRows[draggedData.childIndex];
        draggedRow.StrategyName = updatedRows[parentIndex]?.StrategyName || "Undefined";
        draggedRow.StrategyId = updatedRows[parentIndex]?.StrategyId || "Undefined";
        updatedRows[draggedData.parentIndex].ChildData[0].childRows.splice(draggedData.childIndex, 1);
        updatedRows[parentIndex].ChildData[0].childRows.splice(childIndex, 0, draggedRow);

        if (updatedRows[draggedData.parentIndex].ChildData[0].childRows.length === 0) {
            updatedRows.splice(draggedData.parentIndex, 1);
        }

        setRowDataState(updatedRows);
        setTimeout(() => {
            if (allocationParams.IsInitialChange)
                PercentageCalculation();
        }, 1000);
    };




    // Formatting the number using thousand separators
    const ThousandsSeparators = (num) => {
        if (num != undefined) {
            let num_parts = num.toString().split(".");
            num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            return num_parts.join(".");
        }
    }
    const RemoveThousandSep = (num) => {
        if (num != undefined)
            return parseFloat(num.replace(/,(?=\d{3})/g, ''));
        else
            return 0;
    }

    const PercentageOnChangeCalculation = (type, allocationmode) => {

        let psum = 0;
        let initalvalue = allocationParams.InitialValue;
        let total = 0;
        $('#allocationTable tr[class=strategyRow]').each(function (i, item) {
            $(item).find('input[id=Position]').val($(item).find('input[id=Position]').val().replace('$', ''));
            if (parseInt($(item).find('input[id=Percentage]').val().replace("%", "")) >= 0 || parseInt($(item).find('input[id=Position]').val()) >= 0) {
                if (allocationmode == "0") {
                    let positionVal = ((initalvalue * $(item).find('input[id=Percentage]').val().replace("%", "")) / 100).toFixed(6);
                    $(item).find('input[id=Position]').val(ThousandsSeparators(positionVal));
                }
                else {
                    let psvalue = $(item).find('input[id=Position]').val();
                    if (parseInt(RemoveThousandSep(psvalue)) <= initalvalue) {
                        let percentVal = (parseFloat(RemoveThousandSep(psvalue)) / (initalvalue / 100)).toFixed(6);
                        $(item).find('input[id=Percentage]').val("%" + ' ' + percentVal);
                    }
                    else {
                        $(item).find('input[id=Percentage]').val(0);
                    }
                }
                total = total + ($(item).find('input[id=Percentage]').val().replace("%", "") == '' ? 0 : parseFloat($(item).find('input[id=Percentage]').val().replace("%", "")));
            }
        });
        if (rowDataState.length == 0) {
            $('#StrategyTotal').text("0.00" + '%');
        }
        else {
            $('#StrategyTotal').text(parseFloat(total).toFixed(6) + '%');
        }
        if (type !== "parent") {
          var mode=0;
            $('#allocationTable').on('input', 'tr.dataRow input', function (event) {
                var $currentInput = $(this);
                var $currentRow = $currentInput.closest('tr.dataRow');
                var group = $currentRow.data('group');
                var $currentInput = $(this);
                var inputId = $currentInput.attr('id');
                var value = $currentInput.val();
                var inputType = inputId.includes('Position') ? 'position' : 'percentage';
                if (inputType === "position")
                    mode = "1";
                else
                     mode = "0";
                updateRows($(this).closest('tr.dataRow'), mode, group);
            });

        }
        else {
            $('#allocationTable tr[class=dataRow]').each(function (i, item) {
                $(item).prevAll('tr[class=strategyRow]').first().find('input[id=Position]').val($(item).prevAll('tr[class=strategyRow]').first().find('input[id=Position]').val().replace('$', ''));
                let posval = $(item).prevAll('tr[class=strategyRow]').first().find('input[id=Position]').val();
                // var currentStrategyTotal = parseFloat(RemoveThousandSep(posval) == '' ? 0 : RemoveThousandSep(posval));
                var currentStrategyTotal = parseFloat($(item).prevAll('tr[class=strategyRow]').first().find('input[id=Position]').val() == '' ? 0 : RemoveThousandSep($(item).prevAll('tr[class=strategyRow]').first().find('input[id=Position]').val()));
                if (allocationmode == 0) {
                    if (parseInt($(item).find('td[id=Percentage] input').val()) >= 0 && parseInt($(item).find('td[id=Percentage] input').val()) != " " || parseInt(RemoveThousandSep(posval)) >= 0 && parseInt(RemoveThousandSep(posval)) != " ") {
                        let detailpositionval = ((currentStrategyTotal * $(item).find('td[id=Percentage] input').val()) / 100).toFixed(6);
                        $(item).find('td[id=Position] input').val(ThousandsSeparators(detailpositionval));
                    }
                } else {
                    let detailposval = $(item).find('td[id=Position] input').val();
                    if (RemoveThousandSep(detailposval) <= currentStrategyTotal) {
                        if (parseFloat($(item).find('td[id=Position] input').val()) > 0) {
                            let detailpercentval = (parseFloat(RemoveThousandSep(detailposval)) / (currentStrategyTotal / 100)).toFixed(6);
                            $(item).find('td[id=Percentage] input').val(detailpercentval);
                        } else {
                            $(item).find('td[id=Percentage] input').val(0);
                        }
                    } else {
                        $(item).find('td[id=Percentage] input').val(0);
                    }
                }
                $(item).prevAll('tr[class=strategyRow]').first().find('input[id=Position]').val($(item).prevAll('tr[class=strategyRow]').first().find('input[id=Position]').val());
            });
        }
    }


    function updateRows($currentRow, mode, group) {
        var $rows = $('#allocationTable tr.dataRow[data-group="' + group + '"]');
        var currentIndex = $rows.index($currentRow);
        var currentValue =0;
          //Header value....
          let posval = $currentRow.prevAll('tr.strategyRow').first().find('input[id=Position]').val();
          var currentStrategyTotal = parseFloat($currentRow.prevAll('tr.strategyRow').first().find('input[id=Position]').val() == '' ? 0 : RemoveThousandSep($currentRow.prevAll('tr.strategyRow').first().find('input[id=Position]').val()));
  
if(mode==="0")
{
         currentValue = $currentRow.find('td[id=Percentage] input').val() ;
}
else
{
    $rows.each(function (index) {  
        
        var $row = $(this);  
        var detailposval = parseFloat($row.find('td[id=Position] input').val());
        if (isNaN(detailposval)) {
            detailposval = 0;
        }
    if (index == currentIndex) {
        if (detailposval < currentStrategyTotal || detailposval === currentStrategyTotal )
        {
            if (detailposval > 0) {
              var currentPercentage=(detailposval/ (currentStrategyTotal / 100)).toFixed(6);
             
                $currentRow.find('td[id=Percentage] input').val(currentPercentage);
              
            } else {
                $currentRow.find('td[id=Percentage] input').val(0)
            }
        } else {
            $currentRow.find('td[id=Percentage] input').val(0)
        }
         currentValue = currentPercentage || 0;
    }
})
}
        var total = 100;
        if (currentValue > 100)
            currentValue = 100;
        var remainingTotal = total - currentValue;
        var otherRowsCount = $rows.length - 1;
        var distributedValue = (remainingTotal / otherRowsCount).toFixed(6);

      

        if (mode == "0") {
            $rows.each(function (index) {
                var $row = $(this);
                if (index == currentIndex) {
                    $row.find('td[id=Percentage] input').val(currentValue);
                    if (mode == "0") {
                        if (parseInt($currentRow.find('td[id=Percentage] input').val()) >= 0 && parseInt($currentRow.find('td[id=Percentage] input').val()) != " " || parseInt(RemoveThousandSep(posval)) >= 0 && parseInt(RemoveThousandSep(posval)) != " ") {
                            let detailpositionval = ((currentStrategyTotal * $currentRow.find('td[id=Percentage] input').val()) / 100).toFixed(6);
                            $row.find('td[id=Position] input').val(ThousandsSeparators(detailpositionval));
                        }
                    }


                } else {
                    if (index == $rows.length - 1) {
                        var adjustedValue = (remainingTotal - (distributedValue * (otherRowsCount - 1))).toFixed(6);
                        $row.find('td[id=Percentage] input').val(adjustedValue);
                        if (mode == 0) {
                            if (parseInt($currentRow.find('td[id=Percentage] input').val()) >= 0 && parseInt($currentRow.find('td[id=Percentage] input').val()) != " " || parseInt(RemoveThousandSep(posval)) >= 0 && parseInt(RemoveThousandSep(posval)) != " ") {
                                let detailpositionval = ((currentStrategyTotal * adjustedValue) / 100).toFixed(6);
                                $row.find('td[id=Position] input').val(ThousandsSeparators(detailpositionval));
                            }
                        }


                    } else {
                        if (mode == 0) {
                            $row.find('td[id=Percentage] input').val(distributedValue);
                            if (parseInt($currentRow.find('td[id=Percentage] input').val()) >= 0 && parseInt($currentRow.find('td[id=Percentage] input').val()) != " " || parseInt(RemoveThousandSep(posval)) >= 0 && parseInt(RemoveThousandSep(posval)) != " ") {
                                let detailpositionval = ((currentStrategyTotal * distributedValue) / 100).toFixed(6);
                                $row.find('td[id=Position] input').val(ThousandsSeparators(detailpositionval));
                            }
                        }

                    }
                }

            });
        }
        else 
        {
            $rows.each(function (index) {
                var $row = $(this);
            if (index == currentIndex) {
               
            } else {
                if (index == $rows.length - 1) {
                    var adjustedValue = (remainingTotal - (distributedValue * (otherRowsCount - 1))).toFixed(6);
                    $row.find('td[id=Percentage] input').val(adjustedValue);
                    
                        if (parseInt($currentRow.find('td[id=Percentage] input').val()) >= 0 && parseInt($currentRow.find('td[id=Percentage] input').val()) != " " || parseInt(RemoveThousandSep(posval)) >= 0 && parseInt(RemoveThousandSep(posval)) != " ") {
                            let detailpositionval = ((currentStrategyTotal * adjustedValue) / 100).toFixed(6);
                            $row.find('td[id=Position] input').val(ThousandsSeparators(detailpositionval));
                        
                    }


                } else {
                    
                        $row.find('td[id=Percentage] input').val(distributedValue);
                        if (parseInt($currentRow.find('td[id=Percentage] input').val()) >= 0 && parseInt($currentRow.find('td[id=Percentage] input').val()) != " " || parseInt(RemoveThousandSep(posval)) >= 0 && parseInt(RemoveThousandSep(posval)) != " ") {
                            let detailpositionval = ((currentStrategyTotal * distributedValue) / 100).toFixed(6);
                            $row.find('td[id=Position] input').val(ThousandsSeparators(detailpositionval));
                        }
                    

                }
        
            }
        })
 

        }





    }

    const PercentageCalculation = () => {
        let initalvalue = allocationParams.InitialValue;
        let mode = allocationParams?.AllocationMode?.OptionId;
        let total = 0;
        $('#allocationTable tr[class=strategyRow]').each(function (i, item) {
            $(item).find('input[id=Position]').val($(item).find('input[id=Position]').val().replace('$', ''));
            if (parseInt($(item).find('input[id=Percentage]').val().replace("%", "")) >= 0 || parseInt($(item).find('input[id=Position]').val()) >= 0) {
                if (mode == "0") {
                    let positionVal = ((initalvalue * $(item).find('input[id=Percentage]').val().replace("%", "")) / 100).toFixed(6);
                    $(item).find('input[id=Position]').val(ThousandsSeparators(positionVal));
                }
                else {
                    let psvalue = $(item).find('input[id=Position]').val();
                    if (parseInt(RemoveThousandSep(psvalue)) <= initalvalue) {
                        let percentVal = (parseFloat(RemoveThousandSep(psvalue)) / (initalvalue / 100)).toFixed(6);
                        $(item).find('input[id=Percentage]').val("%" + ' ' + percentVal);
                    }
                    else {
                        $(item).find('input[id=Percentage]').val(0);
                    }
                }
                total = total + ($(item).find('input[id=Percentage]').val().replace("%", "") == '' ? 0 : parseFloat($(item).find('input[id=Percentage]').val().replace("%", "")));
            }
        });

        if (rowDataState.length == 0) {
            $('#StrategyTotal').text("0.00" + '%');
        }
        else {
            $('#StrategyTotal').text(parseFloat(total).toFixed(6) + '%');
        }
        $('#allocationTable tr[class=dataRow]').each(function (i, item) {
            $(item).prevAll('tr[class=strategyRow]').first().find('input[id=Position]').val($(item).prevAll('tr[class=strategyRow]').first().find('input[id=Position]').val().replace('$', ''));
            let posval = $(item).prevAll('tr[class=strategyRow]').first().find('input[id=Position]').val();
            // var currentStrategyTotal = parseFloat(RemoveThousandSep(posval) == '' ? 0 : RemoveThousandSep(posval));
            var currentStrategyTotal = parseFloat($(item).prevAll('tr[class=strategyRow]').first().find('input[id=Position]').val() == '' ? 0 : RemoveThousandSep($(item).prevAll('tr[class=strategyRow]').first().find('input[id=Position]').val()));
            if (mode == 0) {
                if (parseInt($(item).find('td[id=Percentage] input').val()) >= 0 && parseInt($(item).find('td[id=Percentage] input').val()) != " " || parseInt(RemoveThousandSep(posval)) >= 0 && parseInt(RemoveThousandSep(posval)) != " ") {
                    let detailpositionval = ((currentStrategyTotal * $(item).find('td[id=Percentage] input').val()) / 100).toFixed(6);
                    $(item).find('td[id=Position] input').val(ThousandsSeparators(detailpositionval));
                }
            } else {
                let detailposval = $(item).find('td[id=Position] input').val();
                if (RemoveThousandSep(detailposval) <= currentStrategyTotal) {
                    if (parseFloat($(item).find('td[id=Position] input').val()) > 0) {
                        let detailpercentval = (parseFloat(RemoveThousandSep(detailposval)) / (currentStrategyTotal / 100)).toFixed(6);
                        $(item).find('td[id=Percentage] input').val(detailpercentval);
                    } else {
                        $(item).find('td[id=Percentage] input').val(0);
                    }
                } else {
                    $(item).find('td[id=Percentage] input').val(0);
                }
            }
            $(item).prevAll('tr[class=strategyRow]').first().find('input[id=Position]').val($(item).prevAll('tr[class=strategyRow]').first().find('input[id=Position]').val());
        });
    }



    if (allocationParams.IsInitialChange)
        PercentageCalculation();

    const onSaveAs = (mode) => {
        if (
            allocationParams.InitialValue !== null &&
            allocationParams.StartDate.OptionId !== null &&
            allocationParams.EndDate.OptionId !== null &&
            allocationParams.AllocationMode.OptionId !== null &&
            allocationParams.RebalanceMethod.OptionId !== null &&
            allocationParams.RebalanceStart.index !== null &&
            allocationParams.Backfill.OptionId !== null
        ) {
            if (rowDataState.length == 0) {
                SBNotify({
                    type: "warning",
                    Msg: "Add minimum one allocation to save proforma",
                });
            }
            else {
                setAddAssets(false);
                setIsSaveLoading(false);
                if (ActiveButton === "CreateNewProfoma") {
                    setHpName();
                    setDescription();
                }
                else {
                    setHpName(proformaTreeListData?.HPName);
                    setDescription(proformaTreeListData?.Description);
                }
                setShowDrawer(true);
                setSaveAs(true);
                setproformaId(mode === "New" ? 0 : proformaId);

            }
        } else {
            SBNotify({
                type: "warning",
                Msg: "Please select any option from all parameters",
            });

        }
    };

    const saveProfomaName = (mode) => {

        if (
            hpName !== null && hpName !== undefined
        ) {
            setIsSaveLoading(true);
            onSave(mode);
        }
        else {
            SBNotify({
                type: "warning",
                Msg: "Please Enter HpName",
            });
        }
    };

    const assetsAdd = () => {
        setShowDrawer(true);
        setAddAssets(true);
    };

    const handleAddSelectedRows = (newRows) => {
        const updatedDataState = [...rowDataState];
        const updatedSelectedRows = [...selectedRows, ...newRows];

        updatedSelectedRows.forEach((row) => {
            const { StrategyName, EntityName, EntityTypeId, EntityId, StrategyId, Id } = row;

            const existingParent = updatedDataState.find((item) => item.StrategyName === StrategyName);

            if (existingParent) {
                const isDuplicate = existingParent.ChildData[0].childRows.some((childRow) => childRow.EntityId === EntityId);

                if (!isDuplicate) {
                    existingParent.ChildData[0].childRows.push({
                        EntityName: EntityName,
                        StrategyName: StrategyName,
                        StartDate: row.StartDate == null ? new Date() : row.StartDate,
                        EndDate: row.EndDate === null ? new Date() : row.EndDate,
                        ProxyData: [],
                        EntityType: EntityTypeId,
                        EntityId: EntityId,
                        StrategyId: StrategyId,
                        Id: Id,
                    });
                }
            } else {
                // Create a new parent when no existing parent is found
                const isDuplicatek = updatedDataState.some((row) => row.ChildData[0].childRows.some((childRow) => childRow.EntityId === EntityId));

                if (!isDuplicatek) {
                    updatedDataState.push({
                        HypoId: proformaId,
                        StrategyId: StrategyId,
                        StrategyName: StrategyName,
                        EntityId: EntityId,
                        EntityName: null,
                        CurAllocation: "",
                        PerAllocation: "",
                        ChildData: [{
                            childRows: [{
                                EntityName: EntityName,
                                StrategyName: StrategyName,
                                StartDate: row.StartDate == null ? new Date() : row.StartDate,
                                EndDate: row.EndDate === null ? new Date() : row.EndDate,
                                ProxyData: [],
                                EntityType: EntityTypeId,
                                EntityId: EntityId,
                                StrategyId: StrategyId,
                                Id: Id,
                                PerAllocation: 100
                            }]
                        }],
                    });
                }
            }
        });

        setRowDataState(updatedDataState);
    };

    const closeDrawer = () => {
        setShowDrawer(false);
    };

    const EntitiesChange = (e, EntityId) => {
        const inputValue = e.value;
        if (inputValue.length >= 3) {

            // edited on nov 1 due to store latency call but values are dipatched to 
            dispatch(getProformaEntitiesAction(inputValue, true, 0));


            sbaAxios({ url: `${getEntities}/${inputValue},${true},${0}` }).then((response => {
                setProxyList(response)
            })).catch(error => {
                console.log(error);
            });
        }
        else {
            setProxyList([]);
        }
        const Entitydata = Entities.filter((accumulator, eitem) => {
            if (eitem.EntityName === e.value) {
                accumulator.push(eitem);
            }
            return accumulator;
        }, []);

        const data = rowDataState.map((item) => {

            const updatedChildRows = item?.ChildData[0].childRows.map((nestedItem) => {
                if (nestedItem.EntityId === EntityId) {
                    return { ...nestedItem, ProxyData: Entitydata };
                }
                else {
                    return nestedItem;
                }
            });

            return { ...item, ChildData: [{ childRows: updatedChildRows }] };

        });
        setRowDataState(data);

        if (e.syntheticEvent.type === "click") {
            const Entitydata = Entities.reduce((accumulator, item) => {
                if (item.EntityName.toLowerCase() === e.value.toLowerCase()) {
                    accumulator.push(item);
                }
                return accumulator;
            }, []);

            $("#proxyId_" + EntityId + "").val(Entitydata != undefined ? Entitydata[0].EntityId : "");
            $("#proxyTypeId_" + EntityId + "").val(Entitydata != undefined ? Entitydata[0].EntityTypeId : "");
        }


    };
    const [hasException, setHasException] = useState(false);
    const onSave = async (mode) => {
        if (allocationParams.InitialValue !== null &&
            allocationParams.StartDate.OptionId !== null &&
            allocationParams.EndDate.OptionId !== null &&
            allocationParams.AllocationMode.OptionId !== null &&
            allocationParams.RebalanceMethod.OptionId !== null &&
            allocationParams.RebalanceStart.index !== null &&
            allocationParams.Backfill.OptionId !== null
        ) {
            let allocations = [];
            $("#allocationTable tr[class=strategyRow]").each(function (i, item) {
                allocations.push({
                    AllocId: 0,
                    HypoId: $(item).find("td[id=HypoId]").text() || 0,
                    StrategyId: $(item).find("td[id=StrategyId]").text(),
                    StrategyName: $(item).find("td[id=HeaderStrategyName]").text(),
                    Position: $(item)
                        .find("input[id=Position]")
                        .val()
                        .replace(/[$,]/g, "")
                        .trim(),
                    Percentage:
                        $(item).find("input[id=Percentage]").val().replace("%", "").trim() / 100,

                    EntityId: $(item).find("td[id=EntityId]").text(),
                    AllocDate: null,
                    CreatedBy: 0,
                    ModifiedBy: 0,
                    StrategyAlloc: null,
                });
            });

            let hasUndefinedAllocation = allocations.some((item) => item.StrategyName === "Undefined");
            if(hasUndefinedAllocation){
                SBNotify({
                    type: "error",
                    Msg: "You have an Asset under undefined strategy, please correct it.",
                });
                return;
            }

            let EntitiesAllocation = [];
            $("#allocationTable tr[class=dataRow]").each(function (i, item) {
                const proxyId = $(item).find("td[id=proxyId_" + $(item).find("td[id=EntityId]").text() + "]").text();
                const hypoId = $(item).find("td[id=HypoId]").text();
                const proxytype = $(item).find("td[id=proxyTypeId_" + $(item).find("td[id=EntityId]").text() + "]").text();
                const Id = $(item).find("td[id=Id]").text();
                EntitiesAllocation.push({
                    Id: Id === "" ? 0 : Id,
                    HypoId: hypoId === "" ? 0 : hypoId,
                    EntityId: $(item).find("td[id=EntityId]").text(),
                    EntityName: $(item).find("td[id=EntityName]").text(),
                    EntityType: $(item).find("td[id=EntityType]").text(),
                    StrategyId: $(item).find("td[id=StrategyId]").text(),
                    SecMasterId: $(item).find("td[id=SecMasterId]").text() === "" ? 0 : $(item).find("td[id=SecMasterId]").text(),
                    ProxyBenchmarkId: proxyId === undefined || "" ? 0 : proxyId !== "" ? proxyId : $("#proxyId_" + $(item).find("td[id=EntityId]").text() + "").val(),
                    ProxyBenchmarkType: proxytype === undefined || "" ? 0 : proxytype !== "" ? proxytype : $("#proxyTypeId_" + $(item).find("td[id=EntityId]").text() + "").val(),
                    Allocations: [
                        {
                            AllocId: 0,
                            HypoId: 0,
                            StrategyId: $(item).find("td[id=StrategyId]").text(),
                            StrategyName: null,
                            AllocDate: $(item).find("td[id=AllocDate]").text().trim() === "" || "Invalid date" ? null : $(item).find("td[id=AllocDate]").text().trim(),
                            Percentage:
                                $(item)
                                    .find("td[id=Percentage] input")
                                    .val()
                                    .replace("%", "")
                                    .trim() / 100,
                            Position: $(item)
                                .find("td[id=Position] input")
                                .val()
                                .replace(/[$,]/g, "")
                                .trim(),
                            EntityId: 0,
                            CreatedBy: 0,
                            ModifiedBy: 0,
                            StrategyAlloc: null,
                        },
                    ],

                    StrategyName: $(item).find("td[id=StrategyName]").text(),
                    AllocDate: null,
                    Percentage: 0,
                    Position: 0,
                    EntityReturns: null,
                    WorkingReturns: null,
                    ProxyReturns: null,
                    IsCalcEligible: false,
                    StartDate: $(item).find("td[id=StartDate]").text(),
                    EndDate: $(item).find("td[id=EndDate]").text(),
                    SortOrder: $(item).find("td[id=SortOrder]").text() === "" ? 0 : $(item).find("td[id=SortOrder]").text(),
                    ProxyName: null,
                    IsPastInception: false,
                    InceptionCounter: 0,
                    CreatedBy: 0,
                    ModifiedBy: 0,
                });
            });
            const data = {
                hpId: proformaId,
                userId: 0,
                hpName: hpName,
                description: description,
                fromDate: allocationParams?.FromDate,
                // toDate: "2023-10-04T08:20:02.417Z",
                position: allocationParams.InitialValue,
                rfr: 0,
                mainBenchmarkId: 0,
                mainBenchmarkType: 0,
                hypoCalcTypeId: 0,
                hypoCalcType: 0,
                isSimpleMode: true,
                startDateOption: allocationParams?.StartDate?.OptionId,
                endDateOption: allocationParams?.EndDate?.OptionId,
                rebalancingMethod: allocationParams?.RebalanceMethod?.OptionId,
                backfillType: allocationParams?.Backfill?.OptionId,
                addOrEdit: ActiveButton !== "Allocation" ? 0 : 1,
                hypoParameters: [
                    {
                        parameterId: 0,
                        hpId: proformaId || 0,
                        startDateOptionId: allocationParams?.StartDate?.OptionId,
                        startDateOption: allocationParams?.StartDate?.OptionDescription,
                        endDateOptionId: allocationParams?.EndDate?.OptionId,
                        endDateOption: allocationParams?.EndDate?.OptionDescription,
                        rebalanceMethodId: allocationParams?.RebalanceMethod?.OptionId,
                        rebalanceMethod: allocationParams?.RebalanceMethod?.OptionDescription,
                        rebalanceStartId: allocationParams?.RebalanceStart?.index,
                        rebalanceStart: allocationParams?.RebalanceStart?.month,
                        backfillOptionId: allocationParams?.Backfill?.OptionId,
                        backfillOption: allocationParams?.Backfill?.OptionDescription,
                        isDefault: true,
                        createdBy: 0,
                        modifiedBy: 0,
                    },
                ],
                hypoAllocations: allocations,
                hypoEntities: EntitiesAllocation,
                allocationMode: allocationParams?.AllocationMode?.OptionId,
                fundId: 0,
                automateReturns: allocationParams?.AutomatedReturns === null || allocationParams?.AutomatedReturns === "" ? false : allocationParams?.AutomatedReturns,
                feesPercentage: allocationParams?.Fees === "" ? false : allocationParams?.Fees,
                feesPercentageValue: allocationParams?.FeesPercentage === "" ? 0.0 : allocationParams?.FeesPercentage,
                createdBy: 0,
                modifiedBy: 0,
            };

            let percentageValidation = true;

            rowDataState.forEach(function (element, index, list) {
                var total = 0;
                $(element?.ChildData[0].childRows).each(function (i, item) {
                    var percentageInput = $('#Percentage_' + item.EntityId + '').val().replace("%", "").trim();
                    total += parseFloat(percentageInput);
                    if (percentageInput <= 0) {
                        percentageValidation = false;
                    }
                });
                var ftot = 0;
                if (parseFloat(total) >= 100) {
                    ftot = parseFloat(total.toFixed(2));
                }
                else {
                    ftot = parseFloat(total)
                }
                if (ftot !== 100) {
                    percentageValidation = false;
                }
            });
            var stratgeyTotal = 0;
            $('#allocationTable tr[class=strategyRow]').each(function (i, item) {
                stratgeyTotal = stratgeyTotal + parseFloat($(item).find('input[id=Percentage]').val().replace("%", "").trim());
                if (parseFloat($(item).find('input[id=Percentage]').val()) <= 0) {
                    percentageValidation = false;
                }
            });
            setIsSaving(true);
            try {
                const totalValue = $("#StrategyTotal").text();
                if (percentageValidation == false || stratgeyTotal != 100) {
                    setIsSaveLoading(false);
                    SBNotify({
                        type: "error",
                        Msg: "Allocations percentage value not equal to 100%",
                    });
                }
                else {

                    const response = await sbaAxios({

                        url: `${proformaId === 0 ? saveProforma : updateProforma}`,
                        method: "post",
                        data: data,
                    });
                    setIsSaveLoading(false);
                    if ((typeof response === 'number' && response > 0) || (typeof response === 'object' && response.Item1 > 0)) {

                        typeof response === 'number'
                            ? setproformaId(response)
                            : typeof response === 'object' && response.hasOwnProperty('Item1')
                                ? setproformaId(response.Item1)
                                : setproformaId(null);
                        setProfromaID(typeof response === 'number' ? response : null || typeof response === 'object' ? response["Item1"] : null)
                        if (mode == "Edit") {

                            SBNotify({ type: "success", Msg: "Updated Successfully" });
                        }
                        else {

                            SBNotify({ type: "success", Msg: "Saved Successfully" });
                        }
                        setShowDrawer(false);
                        setshowsave(true);
                        if (ActiveButton !== "Allocation") {
                            getproformadetails(typeof response === 'number' ? response : null || typeof response === 'object' ? response["Item1"] : null);
                        }
                        else {

                            setTimeout(() => {
                                dispatch(getProformaListAction());
                                history(`${UrlPath.ProformaConstruction}`);
                            }, 1000);
                        }

                    }
                    else if (response === -999 || response.Item2 === -999) {

                        SBNotify({
                            type: "error",
                            Msg: "No returns data found for selected Entity",
                        });
                    }
                    else if (response === -555) {
                        SBNotify({
                            type: "error",
                            Msg: "Proforma Name Already Exsits",
                        });
                    }
                }
                setIsSaving(false);
                setHasException(false);
            } catch (error) {
                setIsSaving(false);
                setIsSaveLoading(false);
                setHasException(true);
                SBNotify({
                    type: "error",
                    Msg: "Some exception occured,Please contact Administrator",
                });
                setTimeout(() => {
                    setHasException(false); // Resetting hasException to false after a delay
                }, 0);
            }
        } else {
            SBNotify({
                type: "warning",
                Msg: "Please select any option from all parameters",
            });
        }
    };
    const getproformadetails = async (HPID) => {
        try {

            const response = await sbaAxios({
                url: `${getProforma}/${HPID}`,
                method: 'get',
            });
            const data = response;
            const updatedParams = { ...allocationParams };
            if (data.length > 0) {
                updatedParams.StartDate = {
                    "OptionId": data?.HypoParameters ? data?.HypoParameters[0]?.StartDateOptionId : null,
                    "OptionDescription": data?.HypoParameters ? data?.HypoParameters[0]?.StartDateOption : null,
                    "OptionType": "DATE"
                };
                updatedParams.EndDate = {
                    "OptionId": data?.HypoParameters ? data?.HypoParameters[0]?.EndDateOptionId : null,
                    "OptionDescription": data?.HypoParameters ? data?.HypoParameters[0]?.EndDateOption : null,
                    "OptionType": "DATE"
                };
                updatedParams.Backfill = {
                    "OptionId": data?.HypoParameters ? data?.HypoParameters[0]?.BackfillOptionId : null,
                    "OptionDescription": data?.HypoParameters ? data?.HypoParameters[0]?.BackfillOption : null,
                    "OptionType": "BF"
                };
                updatedParams.RebalanceMethod = {
                    "OptionId": data?.HypoParameters ? data?.HypoParameters[0]?.RebalanceMethodId : null,
                    "OptionDescription": data?.HypoParameters ? data?.HypoParameters[0]?.RebalanceMethod : null,
                    "OptionType": "RBM"
                };
                updatedParams.RebalanceStart = data?.HypoParameters ? data?.HypoParameters[0]?.RebalanceStartId : null;
                updatedParams.AllocationMode = data?.AllocationMode;
                updatedParams.AutomatedReturns = data?.AutomateReturns;
                updatedParams.Fees = data?.FeesPercentage;
                updatedParams.FeesPercentage = data?.FeesPercentageValue;
                updatedParams.FromDate = data?.FromDate;
                setAllocationParams(updatedParams);
            }
        } catch (error) {
            console.error("Error fetching entities from API:", error);
        }
    };
    const redirectLinkClick = () => {
        history(`${UrlPath.ProformaConstruction}`);
    };
    const ClearProformaDetails = () => {
        setRowDataState([]);
    }
    const removerowdata = (childEntityId) => {
        const parentStrategyId = findHeaderStrategyId(childEntityId);
        const updatedTableData = rowDataState.map((item) => {
            if (item.StrategyId === parentStrategyId) {
                item.ChildData[0].childRows = item?.ChildData[0].childRows.filter(
                    (nestedItem) => nestedItem.EntityId !== childEntityId
                );
            }
            return item;
        });
        const updatedTableDataWithParents = updatedTableData.filter((item) =>
            item?.ChildData[0].childRows.length > 0
        );
        setRowDataState(updatedTableDataWithParents);
        setTimeout(() => {

            PercentageCalculation();
        }, 500);
    }
    const findHeaderStrategyId = (childEntityId) => {
        for (const item of rowDataState) {
            for (const nestedItem of item?.ChildData[0].childRows) {
                if (nestedItem.EntityId === childEntityId) {
                    return item.StrategyId;
                }
            }
        }
        return null;
    };
    return (
        <>
            <div id="Ptgdiv">
                <div className="d-flex align-items-center justify-content-between">
                    <div className="col-lg-3">
                        <div className="d-flex align-items-center">
                            <h2 className="fw-bold fs-6 m-0">Lists of Details</h2>
                        </div>
                    </div>
                    <div className="col-lg-6 d-flex gap-1 justify-content-lg-end align-items-center">
                        <div>
                            <button
                                type="button"
                                className="s-sm-btn mx-1"
                                onClick={ClearProformaDetails}
                            >
                                Clear All
                            </button>

                            <button
                                type="button"
                                className="p-sm-btn mx-1"
                                disabled={!isEditable}
                                onClick={assetsAdd}
                            >
                                <i className="fa-solid fa-plus" />
                                Add Assets
                            </button>
                        </div>
                    </div>
                </div>
                <div className="col-lg-12 mb-4">
                    <div
                        className="ag-theme-alpine"
                        style={{ width: "100%", height: "350px" }}
                    >
                        <div class="form-group">
                            <div class="col-sm-12">
                                <div className="scrollable-table">
                                    <DndProvider backend={HTML5Backend}>
                                        <table
                                            class="table table-striped"
                                            id="allocationTable"
                                            border="1"
                                        >
                                            <thead>
                                                <tr>
                                                    <th hidden="hidden"></th>
                                                    <th>Name</th>
                                                    <th>Strategy</th>
                                                    <th>Start Date</th>
                                                    <th>End Date</th>
                                                    {allocationParams?.Backfill?.OptionDescription ===
                                                        "ProxyBM" && <th id="proxyHeader">Proxy</th>}
                                                    <th>$ Allocation</th>
                                                    <th>% Allocation</th>
                                                    <th>&nbsp;</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {rowDataState?.map((item, parentIndex) => (
                                                    <React.Fragment key={item?.StrategyId}>
                                                        <tr
                                                            class="strategyRow"
                                                            id={"headertr_" + item?.StrategyId + ""}
                                                        >
                                                            <td id="StrategyId" hidden="hidden">
                                                                {item?.StrategyId}
                                                            </td>
                                                            <td id="HypoId" hidden="hidden">
                                                                {item?.HypoId}
                                                            </td>
                                                            <td id="EntityId" hidden="hidden">
                                                                {item?.EntityId}
                                                            </td>
                                                            <td
                                                                id="HeaderStrategyName"
                                                                style={{
                                                                    backgroundColor: "rgba(33, 150, 243, 0.3)",
                                                                }}
                                                            >
                                                                {item?.StrategyName === null
                                                                    ? "Undefined"
                                                                    : item?.StrategyName}
                                                            </td>
                                                            <td
                                                                style={{
                                                                    backgroundColor: "rgba(33, 150, 243, 0.3)",
                                                                }}
                                                            >
                                                                {item?.EntityName}
                                                            </td>
                                                            <td
                                                                style={{
                                                                    backgroundColor: "rgba(33, 150, 243, 0.3)",
                                                                }}
                                                            ></td>
                                                            <td
                                                                style={{
                                                                    backgroundColor: "rgba(33, 150, 243, 0.3)",
                                                                }}
                                                            >
                                                                { }
                                                            </td>
                                                            
                                                            {allocationParams?.Backfill?.OptionDescription ===
                                                                "ProxyBM" && (
                                                                    <td
                                                                        style={{
                                                                            backgroundColor: "rgba(33, 150, 243, 0.3)",
                                                                        }}
                                                                    >
                                                                        { }
                                                                    </td>
                                                                )}
                                                            <td
                                                                style={{
                                                                    backgroundColor: "rgba(33, 150, 243, 0.3)",
                                                                }}
                                                            >
                                                                <div style={{ display: 'flex',
                                                                    gap: '4px',
                                                                    alignItems: 'center'
                                                                }}>
                                                                     <span >$</span>
                                                                    <input
                                                                        type="text"
                                                                        id="Position"
                                                                        class="numonly form-control"
                                                                        disabled={
                                                                            allocationParams?.AllocationMode
                                                                                ?.OptionId === "0"
                                                                                ? true
                                                                                : false
                                                                        }
                                                                        Value={
                                                                            ThousandsSeparators(item?.CurAllocation)
                                                                        }
                                                                        onChange={() => PercentageOnChangeCalculation("parent", allocationParams?.AllocationMode
                                                                            ?.OptionId)}
                                                                    ></input>
                                                                   
                                                                </div>

                                                            </td>
                                                          
                                                            <td
                                                                style={{
                                                                    backgroundColor: "rgba(33, 150, 243, 0.3)",
                                                                }}
                                                            >
                                                                 <div style={{ display: 'flex',
                                                                    gap: '4px',
                                                                    alignItems: 'center'
                                                                }}>   
                                                                
                                                                
                                                                <input
                                                                    type="text"
                                                                    id="Percentage"
                                                                    class="numonly form-control"
                                                                    Value={
                                                                        + item?.PerAllocation}
                                                                    disabled={
                                                                        allocationParams?.AllocationMode
                                                                            ?.OptionId === "1"
                                                                            ? true
                                                                            : false
                                                                    }
                                                                    onChange={() => PercentageOnChangeCalculation("parent", allocationParams?.AllocationMode
                                                                        ?.OptionId)}
                                                                       
                                                                >
                                                                   
                                                                </input>
                                                                <span >%</span>
                                                                
                                                                </div>
                                                              
                                                            </td>
                                                            <td
                                                                style={{
                                                                    backgroundColor: "rgba(33, 150, 243, 0.3)",

                                                                }}
                                                            >
                                                            </td>

                                                        </tr>
                                                        {item?.ChildData[0]?.childRows.map(
                                                            (nestedItem, childIndex) => (
                                                                <tr
                                                                    key={nestedItem.StrategyId}
                                                                    class="dataRow"
                                                                    data-group={item.StrategyName}
                                                                    id={"dr_" + nestedItem.EntityId + ""}
                                                                    draggable
                                                                    onDragStart={(e) =>
                                                                        handleDragStart(e, parentIndex, childIndex)
                                                                    }
                                                                    onDragOver={(e) =>
                                                                        handleDragOver(e, parentIndex, childIndex)
                                                                    }
                                                                    onDrop={(e) =>
                                                                        handleDrop(e, parentIndex, childIndex)
                                                                    }
                                                                >
                                                                    <td id="StrategyId" hidden="hidden">
                                                                        {nestedItem?.StrategyId}
                                                                    </td>
                                                                    <td id="Id" hidden="hidden">
                                                                        {nestedItem.Id}
                                                                    </td>
                                                                    <td id="SecMasterId" hidden="hidden">
                                                                        {nestedItem.SecMasterId}
                                                                    </td>
                                                                    <td id="EntityId" hidden="hidden">
                                                                        {nestedItem.EntityId}
                                                                    </td>
                                                                    <td id="EntityType" hidden="hidden">
                                                                        {nestedItem.EntityType}
                                                                    </td>
                                                                    <td id="HypoId" hidden="hidden">
                                                                        {nestedItem.HypoId}
                                                                    </td>
                                                                    <td id="AllocDate" hidden="hidden">
                                                                        {" "}
                                                                        {nestedItem.AllocDate}
                                                                    </td>
                                                                    <td id="SortOrder" hidden="hidden">
                                                                        {nestedItem.SortOrder}
                                                                    </td>
                                                                    <td id="EntityName">
                                                                        {nestedItem.EntityName}
                                                                    </td>
                                                                    <td id="StrategyName">
                                                                        {nestedItem.StrategyName === null
                                                                            ? "Undefined"
                                                                            : nestedItem.StrategyName}
                                                                    </td>
                                                                    <td id="StartDate">
                                                                        {moment(nestedItem.StartDate).format(
                                                                            "MM-DD-YYYY"
                                                                        )}
                                                                    </td>
                                                                    <td id="EndDate">
                                                                        {moment(nestedItem.EndDate).format(
                                                                            "MM-DD-YYYY"
                                                                        )}
                                                                    </td>
                                                                    {allocationParams?.Backfill
                                                                        ?.OptionDescription === "ProxyBM" && (
                                                                            <td id="ProxyData">
                                                                                <AutoComplete
                                                                                    // before editing data was binded to store and
                                                                                    //data={nestedItem.ProxyData}

                                                                                    //edited on nov 1 chpo01 data binded to local state of this compoenent
                                                                                    data={proxyList}
                                                                                    defaultValue={
                                                                                        nestedItem.ProxyData != undefined
                                                                                            ? nestedItem.ProxyData.length > 0
                                                                                                ? nestedItem.ProxyData.length ===
                                                                                                    1
                                                                                                    ? nestedItem.ProxyData[0] &&
                                                                                                        typeof nestedItem.ProxyData[0]
                                                                                                            .EntityName === "string"
                                                                                                        ? nestedItem.ProxyData[0]
                                                                                                            .EntityName
                                                                                                        : ""
                                                                                                    : nestedItem.ProxyData &&
                                                                                                        typeof nestedItem.ProxyData ===
                                                                                                        "string"
                                                                                                        ? nestedItem.ProxyData
                                                                                                        : ""
                                                                                                : ""
                                                                                            : ""
                                                                                    }
                                                                                    textField={"EntityName"}
                                                                                    valueField={"EntityId"}
                                                                                    popupSettings={{
                                                                                        style: "z-index:1051",
                                                                                        className: "modalDD",
                                                                                    }}
                                                                                    onChange={(e) => {
                                                                                        EntitiesChange(
                                                                                            e,
                                                                                            nestedItem.EntityId
                                                                                        );
                                                                                    }}
                                                                                    clearButton={false}
                                                                                />
                                                                            </td>
                                                                        )}
                                                                    <td
                                                                        id={"proxyId_" + nestedItem.EntityId + ""}
                                                                        hidden="hidden"
                                                                    >
                                                                        {nestedItem.ProxyBenchmarkId}
                                                                    </td>
                                                                    <td
                                                                        id={
                                                                            "proxyTypeId_" + nestedItem.EntityId + ""
                                                                        }
                                                                        hidden="hidden"
                                                                    >
                                                                        {nestedItem.ProxyBenchmarkType}
                                                                    </td>
                                                                    <td id="Position" style={{ width: "12%" }}>
                                                                    <div style={{ display: 'flex',
                                                                    gap: '4px',
                                                                    alignItems: 'center'
                                                                }}>
                                                                    <span >$</span>
                                                                        <input
                                                                            type="text"
                                                                            id={"Position_" + nestedItem.Id}
                                                                            class="numonly form-control"
                                                                            Value={ThousandsSeparators(
                                                                                nestedItem?.CurAllocation
                                                                            )}
                                                                            disabled={
                                                                                allocationParams?.AllocationMode
                                                                                    ?.OptionId === "0"
                                                                                    ? true
                                                                                    : false
                                                                            }
                                                                            onChange={() => PercentageOnChangeCalculation("Child", "1")}
                                                                        ></input>
                                                                        </div>
                                                                    </td>
                                                                    <td id="Percentage" style={{ width: "12%" }}>
                                                                    <div style={{ display: 'flex',
                                                                    gap: '4px',
                                                                    alignItems: 'center'
                                                                }}>
                                                                   
                                                                        <input
                                                                            type="text"
                                                                            id={"Percentage_" + nestedItem.EntityId}
                                                                            class="numonly form-control"
                                                                            Value={
                                                                                nestedItem?.PerAllocation !== undefined
                                                                                    ? nestedItem?.PerAllocation
                                                                                    : 0
                                                                            }
                                                                            disabled={
                                                                                allocationParams?.AllocationMode
                                                                                    ?.OptionId === "1"
                                                                                    ? true
                                                                                    : false
                                                                            }
                                                                            onChange={() => PercentageOnChangeCalculation("Child", "0")}
                                                                        ></input>
                                                                         <span >%</span>
                                                                         </div>
                                                                    </td>
                                                                    <td class="text-center">
                                                                        {/* <i
                                  className="fa fa-trash"
                                  style={{
                                    color: "#DF001B",
                                    margin: "0 8px",
                                    cursor: "pointer",
                                  }}
                                ></i> */}
                                                                        <i
                                                                            class="fa fa-times"
                                                                            style={{
                                                                                margin: "0% 8px 8px",
                                                                                color: "red",
                                                                                cursor: "pointer",
                                                                            }}
                                                                            onClick={() => {
                                                                                removerowdata(nestedItem.EntityId);
                                                                            }}
                                                                        ></i>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        )}
                                                    </React.Fragment>
                                                ))}
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                    <th
                                                        colspan={
                                                            allocationParams?.Backfill?.OptionDescription ===
                                                                "ProxyBM"
                                                                ? "6"
                                                                : "5"
                                                        }
                                                        style={{ backgroundColor: "#EAF6FF" }}
                                                        class="text-right"
                                                    >
                                                        Total
                                                    </th>
                                                    <th
                                                        colspan="2"
                                                        style={{ backgroundColor: "#EAF6FF" }}
                                                        class="text-left"
                                                        id="StrategyTotal"
                                                    ></th>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </DndProvider>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {ActiveButton === "Allocation" && (
                <div className="col-lg-12">
                    <div className="col-lg-12 d-flex gap-1 justify-content-lg-end align-items-center">
                        <div>
                            <button type="button" className="s-sm-btn mx-1">
                                Cancel
                            </button>
                        </div>
                        <div>
                            <button
                                type="button"
                                className="p-sm-btn mx-1"
                                disabled={!isEditable}
                                onClick={() => onSaveAs("New")}
                            >
                                Save As
                            </button>
                        </div>
                        <div>
                            <button
                                type="button"
                                className="p-sm-btn mx-1"
                                disabled={!isEditable || isSaving || hasException}
                                onClick={() => onSave("Edit")}
                            >
                                Update
                                {isSaving ? "" : ""}
                            </button>
                            {updateMessage && <div>{updateMessage}</div>}
                        </div>
                    </div>
                </div>
            )}
            {ActiveButton !== "Allocation" && (
                <div className="col-lg-12">
                    <div className="col-lg-12 d-flex gap-1 justify-content-lg-end align-items-center">
                        <div>
                            <button
                                type="button"
                                className="s-sm-btn mx-1"
                                onClick={redirectLinkClick}
                            >
                                Cancel
                            </button>
                        </div>
                        <div>
                            <button
                                type="button"
                                className="p-sm-btn mx-1"
                                onClick={() => onSaveAs("New")}
                            >
                                Save As
                            </button>
                        </div>
                        {showsave && (

                            <button
                                type="button"
                                className="p-sm-btn mx-1"
                                onClick={() => onSave("Edit")}
                                disabled={!isEditable || isSaving || hasException}
                            >
                                Save
                                {isSaving ? "" : ""}
                            </button>
                        )}
                    </div>
                </div>
            )}

            {saveAs && (

                <SBADrawer
                    open={showDrawer}
                    setOpen={setShowDrawer}
                    close={false}
                    title={"Save Proforma Name"}
                >
                    {isSaveLoading ?
                        <><LoadingScreen /></> :
                        <div>

                            <div className="mb-4">
                                <label className="header-container m-1">
                                    <b>Name</b>
                                </label>
                                <div>
                                    <input
                                        id="Name"
                                        className="form-control w-75"
                                        type="text"
                                        value={hpName}
                                        onChange={(e) => {
                                            setHpName(e.target.value);
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="mb-4">
                                <label className="header-container m-1">
                                    <b>Description</b>
                                </label>
                                <div>
                                    <input
                                        id="Description"
                                        className="form-control w-75"
                                        type="text"
                                        value={description}
                                        onChange={(e) => {
                                            setDescription(e.target.value);
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="mt-4">
                                <button className="s-sm-btn mx-1" onClick={closeDrawer}>
                                    Cancel
                                </button>
                                <button
                                    className="p-sm-btn mx-1"
                                    onClick={() => saveProfomaName("New")}
                                >
                                    Save
                                </button>
                            </div>
                        </div>
                    }
                </SBADrawer>
            )}
            {addAssets && (
                <SBADrawer
                    open={showDrawer}
                    setOpen={setShowDrawer}
                    close={false}
                    title={`Search `}
                    size={"lg"}
                >
                    <AssetandGroup
                        setShowDrawer={setShowDrawer}
                        handleAddSelectedRows={handleAddSelectedRows}
                    />
                </SBADrawer>
            )}
            <ToastContainer />
        </>
    );
};
